export default __webpack_public_path__ + "static/media/gsk.e4f28aab.png";